var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FCF4F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20.8,
    stroke: "white",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.3516C26.5589 14.3516 29.013 15.3681 30.8225 17.1775C32.6319 18.987 33.6484 21.4411 33.6484 24C33.6484 26.5589 32.6319 29.013 30.8225 30.8225C29.013 32.6319 26.5589 33.6484 24 33.6484C21.4411 33.6484 18.987 32.6319 17.1775 30.8225C15.3681 29.013 14.3516 26.5589 14.3516 24C14.3516 21.4411 15.3681 18.987 17.1775 17.1775C18.987 15.3681 21.4411 14.3516 24 14.3516ZM24 35.875C27.1494 35.875 30.1699 34.6239 32.3969 32.3969C34.6239 30.1699 35.875 27.1494 35.875 24C35.875 20.8506 34.6239 17.8301 32.3969 15.6031C30.1699 13.3761 27.1494 12.125 24 12.125C20.8506 12.125 17.8301 13.3761 15.6031 15.6031C13.3761 17.8301 12.125 20.8506 12.125 24C12.125 27.1494 13.3761 30.1699 15.6031 32.3969C17.8301 34.6239 20.8506 35.875 24 35.875ZM24 18.0625C23.3831 18.0625 22.8867 18.5588 22.8867 19.1758V24.3711C22.8867 24.988 23.3831 25.4844 24 25.4844C24.6169 25.4844 25.1133 24.988 25.1133 24.3711V19.1758C25.1133 18.5588 24.6169 18.0625 24 18.0625ZM25.4844 28.4531C25.4844 28.0594 25.328 27.6819 25.0496 27.4035C24.7712 27.1251 24.3937 26.9688 24 26.9688C23.6063 26.9688 23.2288 27.1251 22.9504 27.4035C22.672 27.6819 22.5156 28.0594 22.5156 28.4531C22.5156 28.8468 22.672 29.2244 22.9504 29.5027C23.2288 29.7811 23.6063 29.9375 24 29.9375C24.3937 29.9375 24.7712 29.7811 25.0496 29.5027C25.328 29.2244 25.4844 28.8468 25.4844 28.4531Z",
    fill: "#A53030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9e653be1.svg";
export { ForwardRef as ReactComponent };